import { useState, useEffect } from 'react';

import sendAxios from '@lcsc-ui/utils/request';
import Image from 'next/image';

import API from '@/apis/index';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { h5BaseURL } from '@/utils/baseUrl';

export default function CouponListPopup({ data, open, onClose }) {
  const [couponList, setCouponList] = useState([]);

  useEffect(() => {
    if (data) {
      getCouponList();
    }
  }, [data]);

  const getCouponList = () => {
    let couponUrl = `${API.activityCoupon}?productId=${data?.productRecord?.productId}`;
    if (data?.isOversea) {
      couponUrl = `${API.activityCoupon}?isOversea=1`;
    }
    sendAxios({
      method: 'GET',
      baseURL: 'lcscActivityUrl',
      url: couponUrl,
    }).then(({ result }) => {
      const { waitReceive, plusList, receive } = result || {};
      setCouponList([].concat(waitReceive || [], plusList || [], receive || []));
    });
  };

  const getCoupon = () => {
    window.location.href = `${h5BaseURL}/pages/get-coupon/index?fromPage=pc_item`;
  };

  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent side="bottom" className="p-0 rounded-t-[8px] max-h-[80vh] overflow-hidden">
        <SheetHeader className="p-4">
          <SheetTitle>优惠券列表</SheetTitle>
        </SheetHeader>
        <div className="max-h-[355px] pb-[10px] overflow-y-auto">
          {couponList.map((item, index) => (
            <div
              key={index}
              className="w-[357px] h-[94px] flex justify-between text-[12px] mb-[10px] m-auto bg-[url('https://static.szlcsc.com/ecp/assets/app/product-detail/coupon.png')] bg-cover bg-no-repeat"
            >
              <div className="w-[249px] h-[92px] ml-[10px] mt-[12px]">
                <div className="flex items-center">
                  {item.customerType === 'plus' ? (
                    <Image
                      className="rounded-[2px]"
                      src="https://static.szlcsc.com/ecp/assets/app/product-detail/plus.png"
                      alt=""
                      width={60}
                      height={18}
                    />
                  ) : item.couponType === 'product' || item.couponType === 'discount' ? (
                    <div className="w-[48px] h-[18px] text-[#ff4960] text-center leading-[16px] text-[12px] rounded-[2px] border border-solid border-[#ea494a]">
                      {item.couponType === 'product' ? '商品券' : '折扣券'}
                    </div>
                  ) : item.couponType === 'plus' ? (
                    <div className="px-[4px] h-[18px] text-[#ff4960] text-center leading-[16px] text-[12px] rounded-[2px] border border-solid border-[#ea494a]">
                      plus会费券
                    </div>
                  ) : (
                    <div className="w-[48px] h-[18px] text-[#0093e6] text-center leading-[16px] text-[12px] rounded-[2px] border border-solid border-[#0093e6]">
                      {item.isFreeExpress ? '包邮券' : '运费券'}
                    </div>
                  )}
                  <span className="ml-[4px] text-[16px]">满{item.minOrderMoney}可用</span>
                </div>
                <div className="mt-[8px] text-[#69788a]">{item.couponName}</div>
              </div>
              <div className="w-[96px] h-[92px] text-[#ff4960] text-[12px]">
                <div className="h-[40px] leading-[40px] text-center text-[#ff4960] text-[20px] mt-[10px] mb-[4px] m-auto">
                  {item.isFreeExpress ? (
                    <span>包邮</span>
                  ) : item.couponType === 'discount' ? (
                    <div>
                      <span>{Math.round(item.couponDiscount * 100) / 1000}</span>
                      <span className="text-[14px]">折</span>
                    </div>
                  ) : (
                    <div>
                      <span className="text-[14px]">￥</span>
                      <span>{item.couponAmount}</span>
                    </div>
                  )}
                </div>
                <div
                  className="w-[60px] h-[26px] leading-[26px] text-center text-[12px] m-auto rounded-[4px] border border-solid border-[#ea494a]"
                  onClick={() => getCoupon()}
                >
                  {item.status === 'receive' ? '已领取' : '立即领取'}
                </div>
              </div>
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
